import type { CopyCatalog } from "./copyTypes";

export const SK_COPY: CopyCatalog = {
  "common.loading": "Načítava sa…",
  "common.yes": "Áno",
  "common.no": "Nie",
  "common.notProvided": "Neuvedené",
  "common.notRequired": "Nie je požadované",
  "common.requested": "Požadované",
  "nav.back": "Späť",
  "nav.continue": "Pokračovať",
  "nav.sendRequest": "Odoslať žiadosť",
  "nav.sending": "Odosiela sa…",
  "alert.completeFields": "Pred pokračovaním vyplňte označené polia.",
  "fill.filled": "Vyplnené",
  "fill.notFound": "Nenájdené",
  "fill.shipmentToo": "Zásielka tiež vyplnená: {detail}",
  "fill.palletMany": "paliet",

  "choose.title": "Ako chcete požiadať o cenovú ponuku?",
  "choose.manual.title": "Manuálne zadanie",
  "choose.manual.description": "Zadajte údaje o zásielke krok za krokom pomocou sprievodného formulára.",
  "choose.manual.action": "Zadať údaje manuálne",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Prilepte údaje o zásielke alebo nahrajte dokument a formulár vyplníme za vás.",
  "choose.quickfill.action": "Spustiť rýchle vyplnenie",

  "steps.route": "Trasa a objednávka",
  "steps.shipment": "Zásielka",
  "steps.services": "Ďalšie služby",
  "steps.contact": "Kontakt",
  "steps.review": "Kontrola",

  "page.route": "Trasa a objednávka",
  "page.routeSection": "Trasa",
  "page.shipment": "Údaje o zásielke",
  "page.services": "Ďalšie služby",
  "page.contact": "Kontaktné údaje",
  "page.contactSection": "Vaše kontaktné údaje",
  "page.review": "Kontrola",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analýza vášho dokumentu",

  "route.hintPostcode": "Zadajte PSČ alebo mesto pre nakládku a vykládku.",
  "route.hintFullAddress": "Zadajte úplnú adresu nakládky a vykládky.",
  "route.unsupported": "Táto trasa nie je podporovaná. Použite formulár pre {loadCountry} a {unloadCountry}.",
  "route.loading": "Nakládka",
  "route.unloading": "Vykládka",
  "route.origin": "Pôvod",
  "route.destination": "Cieľ",
  "route.country": "Krajina",
  "route.selectCountry": "Vyberte krajinu",
  "route.postcode": "PSČ",
  "route.postcodePlaceholder": "napr. 811 01",
  "route.city": "Mesto",
  "route.cityPlaceholder": "Zadajte mesto",
  "route.street": "Názov ulice",
  "route.streetPlaceholder": "Zadajte ulicu",
  "route.house": "Súpisné číslo",
  "route.housePlaceholder": "napr. 12",
  "route.pickupDate": "Preferovaný dátum vyzdvihnutia:",
  "route.unloadDate": "Preferovaný dátum vykládky:",
  "route.datePlaceholder": "dd. mm. rrrr",
  "date.clear": "Vymazať dátum",
  "date.closeCalendar": "Zavrieť kalendár",
  "date.openCalendar": "Otvoriť kalendár",
  "route.specificDateHint":
    "Pre tovar dostupný v konkrétny dátum. Inak sa snažíme o najrýchlejšiu možnosť.",
  "route.orderDetails": "Údaje objednávky",

  "shipment.goods": "Opis tovaru",
  "shipment.goodsPlaceholder": "Čo chcete prepraviť?",
  "shipment.weight": "Celková hmotnosť",
  "shipment.qty": "Množ.",
  "shipment.type": "Typ",
  "shipment.dims": "Rozmery / LDM",
  "shipment.stackable": "Stohovateľné",
  "shipment.addRow": "Pridať riadok zásielky",
  "shipment.totalLines": "Celkový počet riadkov: {count}",
  "shipment.selectDims": "Vyberte rozmery",
  "shipment.dimsNa": "Rozmery sa neuplatňujú",
  "shipment.sizeModeDims": "D × Š × V",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Odstrániť riadok zásielky {n}",
  "shipment.lineLabel": "{text}, riadok {n}",
  "shipment.quantity": "Množstvo",
  "qty.decrease": "Znížiť množstvo",
  "qty.increase": "Zvýšiť množstvo",
  "shipment.lengthCm": "Dĺžka (cm)",
  "shipment.widthCm": "Šírka (cm)",
  "shipment.heightCm": "Výška (cm)",
  "shipment.dimensions": "Rozmery",
  "shipment.size": "Veľkosť",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Polovičná paleta",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Na mieru",
  "pallet.unspecified": "LDM",

  "services.aria": "Ďalšie služby",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Teplota",
  "services.pill.tail": "Hydraulická rampa",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Časové okno",
  "services.pill.ref": "Referencia / poznámky",
  "services.pill.references": "Referencie",
  "services.pill.attachments": "Ďalšie prílohy",
  "services.adrClass": "Trieda ADR",
  "services.selectClass": "Vyberte triedu",
  "services.unNumber": "Číslo OSN",
  "services.unPlaceholder": "napr. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Hydraulická rampa pri nakládke",
  "services.tailUnload": "Hydraulická rampa pri vykládke",
  "services.ftlCopy": "Požadovaná je plná nakládka.",
  "services.invoiceRef": "Referencia faktúry",
  "services.reference": "Referencia",
  "services.loadingRef": "Referencia nakládky",
  "services.unloadingRef": "Referencia vykládky",
  "services.notes": "Poznámky",
  "services.notesPlaceholder": "napr. osobitné pokyny",
  "services.deadline": "Preferovaný termín dodania:",
  "services.deliveryHint":
    "Pre tovar, ktorý treba doručiť v konkrétny dátum. Inak sa snažíme o najrýchlejšiu možnosť.",
  "services.loadingTime": "Čas nakládky",
  "services.unloadingTime": "Čas vykládky",
  "services.window": "Okno",
  "services.fixed": "Pevný",
  "services.at": "o",
  "services.from": "od",
  "services.to": "do",
  "services.timeTypeAria": "Typ {title}",
  "services.addFiles": "Pridať súbory",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP alebo PDF. Až {maxFiles} súborov, {maxFileMb} MB každý, spolu {maxTotalMb} MB.",
  "services.adrClass1": "1 Výbušné látky",
  "services.adrClass2": "2 Plyny",
  "services.adrClass3": "3 Horľavé kvapaliny",
  "services.adrClass4": "4 Horľavé tuhé látky",
  "services.adrClass5": "5 Oxidačné látky",
  "services.adrClass6": "6 Jedovaté / infekčné látky",
  "services.adrClass7": "7 Rádioaktívne látky",
  "services.adrClass8": "8 Žieravé látky",
  "services.adrClass9": "9 Rôzne nebezpečné látky",
  "services.summary.adr": "Nebezpečný tovar (ADR)",
  "services.summary.temp": "Regulovaná teplota",
  "services.summary.time": "Časové okná",
  "services.summary.refNotes": "Referencia a poznámky",
  "services.summary.tail": "Hydraulická rampa",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Ďalšie prílohy",
  "services.tail.loadUnload": "Nakládka a vykládka",
  "services.tail.loadOnly": "Len nakládka",
  "services.tail.unloadOnly": "Len vykládka",
  "services.time.load": "Nakládka: {value}",
  "services.time.unload": "Vykládka: {value}",
  "services.time.deadline": "Termín: {value}",
  "services.time.fixedSuffix": "{time} (pevný)",
  "services.time.windowRange": "{from} až {until}",
  "services.adr.yes": "Áno",
  "services.adr.classUn": "Trieda {class}, OSN {un}",
  "services.adr.classOnly": "Trieda {class}",
  "services.adr.unOnly": "OSN {un}",
  "services.temp.range": "{min}°C až {max}°C",
  "services.ref.invoice": "Faktúra: {value}",
  "services.ref.loading": "Nakládka: {value}",
  "services.ref.unloading": "Vykládka: {value}",

  "contact.name": "Meno",
  "contact.company": "Spoločnosť",
  "contact.email": "E-mail",
  "contact.phone": "Telefón",
  "contact.comment": "Dodatočná poznámka",
  "contact.privacyBefore":
    "Súhlasím so spracovaním mojich osobných údajov v súlade so ",
  "contact.privacyLink": "zásadami ochrany súkromia",
  "contact.privacyAfter": " spoločnosti Neele-Vat.",

  "result.thankYou": "Ďakujeme! Vašu žiadosť sme prijali.",
  "result.teamWillContact":
    "Náš tím vás bude kontaktovať do 60 minút počas pracovných hodín.",
  "result.teamWillContactEmail":
    "Náš tím vás bude kontaktovať do 60 minút počas pracovných hodín na {email}.",
  "result.previewMode": "Režim ukážky — táto žiadosť nebola skutočne odoslaná.",
  "result.previewFiles": " Poznámka: súbory sa v režime ukážky nedajú odoslať.",
  "result.yourReference": "Vaša referencia",
  "result.copy": "Kopírovať",
  "result.copied": "Skopírované",
  "result.nextTitle": "Čo bude nasledovať",
  "result.next1": "Žiadosť prijatá.",
  "result.next2": "Žiadosť sa posudzuje.",
  "result.next3": "Odpoveď do 60 minút e-mailom.",
  "result.logged":
    "Vašu žiadosť sme zaznamenali. Ak sa neozveme, kontaktujte nás podľa údajov nižšie.",
  "result.newQuote": "Začať novú ponuku",
  "result.sendFailed": "Vašu žiadosť sa nepodarilo odoslať",
  "result.preferDirect": "Chcete nás radšej kontaktovať priamo?",
  "result.backToEdit": "Späť na úpravy",
  "result.tryAgain": "Skúsiť znova",
  "result.hideDetails": "Skryť podrobnosti",
  "result.viewSent": "Zobraziť, čo sme odoslali",
  "result.error.rateLimited":
    "V krátkom čase ste odoslali veľa žiadostí. Počkajte chvíľu a skúste to znova.",
  "result.error.forbidden":
    "Táto žiadosť bola zablokovaná. Skúste to znova alebo nás kontaktujte priamo.",
  "result.error.network":
    "Žiadosť sa teraz nepodarilo odoslať. Skontrolujte pripojenie a skúste to znova.",
  "result.error.tooLarge":
    "Žiadosť je na odoslanie príliš veľká. Použite menšie prílohy alebo kratšiu poznámku.",
  "result.error.unsupportedType": "Používajte len JPEG, PNG, GIF, WebP alebo PDF.",
  "result.error.emailUnavailable":
    "Žiadosť s prílohami sa nepodarilo odoslať e-mailom. Skúste to znova alebo nás kontaktujte priamo.",

  "qf.hint":
    "Prilepte e-mail alebo údaje o zásielke, prípadne priložte obrázok alebo PDF. Tým sa nahradia už zadané údaje.",
  "qf.placeholder":
    "napr. 24 euro paliet z 3011 Rotterdamu do 20095 Hamburgu, 12 000 kg, vyzdvihnutie zajtra…",
  "qf.ariaPaste": "Údaje o zásielke na analýzu",
  "qf.attach": "Priložiť obrázok alebo PDF",
  "qf.disclaimer":
    "Všetko, čo prilepíte alebo priložíte, sa používa len na vyplnenie tejto žiadosti. Spracúva to naša služba analýzy dokumentov a po vyplnení formulára sa to neukladá.",
  "qf.fillForm": "Vyplniť formulár",
  "qf.working": "Spracovanie…",
  "qf.analyzing": "Analýza vašich údajov…",
  "qf.noFields": "Nepodarilo sa rozpoznať polia. Pridajte viac podrobností.",
  "qf.rateLimited": "Odoslali ste príliš veľa žiadostí. Počkajte chvíľu a skúste to znova.",
  "qf.blocked": "Táto žiadosť bola zablokovaná. Kontaktujte nás, ak je to neočakávané.",
  "qf.extractUnavailable":
    "Analýza dokumentov momentálne nie je k dispozícii. Namiesto toho prilepte údaje o zásielke.",
  "qf.genericError": "Niečo sa pokazilo. Skontrolujte sieť alebo skúste znova.",
  "qf.analyzeTitle": "Analýza vášho dokumentu...",
  "qf.analyzeSub": "Zvyčajne to trvá niekoľko sekúnd",
  "qf.analyzeStep1": "Čítanie štruktúry dokumentu",
  "qf.analyzeStep2": "Extrakcia základných údajov",
  "qf.analyzeStep3": "Rozpoznávanie riadkov zásielky",
  "qf.removeFile": "Odstrániť {name}",

  "error.loadCountry": "Vyberte krajinu nakládky.",
  "error.loadPostal": "Zadajte PSČ nakládky.",
  "error.loadCity": "Zadajte mesto nakládky.",
  "error.loadStreet": "Zadajte názov ulice nakládky.",
  "error.loadHouseNumber": "Zadajte súpisné číslo nakládky.",
  "error.unloadCountry": "Vyberte krajinu vykládky.",
  "error.unloadPostal": "Zadajte PSČ vykládky.",
  "error.unloadCity": "Zadajte mesto vykládky.",
  "error.unloadStreet": "Zadajte názov ulice vykládky.",
  "error.unloadHouseNumber": "Zadajte súpisné číslo vykládky.",
  "error.pickupDate": "Vyberte dátum vyzdvihnutia.",
  "error.unloadDate": "Vyberte dátum vykládky.",
  "error.invalidDate": "Zadajte platný dátum.",
  "error.totalWeight": "Zadajte celkovú hmotnosť.",
  "error.goods": "Opíšte tovar.",
  "error.loadCityOrPostal": "Zadajte PSČ alebo mesto nakládky.",
  "error.unloadCityOrPostal": "Zadajte PSČ alebo mesto vykládky.",
  "error.loadPostalInvalid": "Zadajte rozpoznané PSČ nakládky.",
  "error.loadCityInvalid": "Zadajte rozpoznané mesto nakládky.",
  "error.unloadPostalInvalid": "Zadajte rozpoznané PSČ vykládky.",
  "error.unloadCityInvalid": "Zadajte rozpoznané mesto vykládky.",
  "error.pickupPast": "Dátum vyzdvihnutia nesmie byť v minulosti.",
  "error.unloadPast": "Dátum vykládky nesmie byť v minulosti.",
  "error.unloadBeforePickup": "Dátum vykládky nesmie byť skôr ako dátum vyzdvihnutia.",
  "error.weightRange": "Zadajte hmotnosť od 1 do {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Zadajte 4-ciferné číslo OSN.",
  "error.invoiceRef": "Zadajte referenciu faktúry.",
  "error.loadingRef": "Zadajte referenciu nakládky.",
  "error.unloadingRef": "Zadajte referenciu vykládky.",
  "error.tempMin": "Zadajte minimálnu teplotu.",
  "error.tempMax": "Zadajte maximálnu teplotu.",
  "error.tempOrder": "Maximum musí byť aspoň minimum.",
  "error.enterNumber": "Zadajte číslo.",
  "error.deliveryPast": "Termín dodania nesmie byť v minulosti.",
  "error.deliveryBeforePickup": "Termín dodania nesmie byť skôr ako dátum vyzdvihnutia.",
  "error.tailSides": "Vyberte nakládku, vykládku alebo oboje.",
  "error.attachOne": "Priložte aspoň jeden súbor.",
  "error.enterTime": "Zadajte čas.",
  "error.enterStartTime": "Zadajte čas začiatku.",
  "error.enterEndTime": "Zadajte čas konca.",
  "error.enterMinutes": "Zadajte minúty.",
  "error.completeTime": "Zadajte úplný čas.",
  "error.enterEmail": "Zadajte e-mailovú adresu.",
  "error.validEmail": "Zadajte platnú e-mailovú adresu.",
  "error.validPhone": "Zadajte platné telefónne číslo.",
  "error.personalEmail": "Súkromné e-mailové adresy sa neprijímajú.",
  "error.enterName": "Zadajte svoje meno.",
  "error.enterCompany": "Zadajte svoju spoločnosť.",
  "error.privacy": "Na pokračovanie súhlaste.",
  "error.quickFillEmpty":
    "Prilepte údaje o zásielke alebo priložte obrázok či PDF na vyplnenie formulára.",
  "error.maxFiles": "Môžete priložiť až {max} súborov.",
  "error.maxFileMb": "Každý súbor smie mať najviac {max} MB.",
  "error.maxTotalMb": "Prílohy smú mať spolu najviac {max} MB.",
  "error.filesSkippedType": "Niektoré súbory boli vynechané. Použite JPEG, PNG, GIF, WebP alebo PDF.",
  "error.emptySkipped": "Prázdne súbory boli vynechané.",
  "error.fileEmpty": "Vybraný súbor je prázdny.",
  "error.filesEmptyOrType": "Niektoré súbory boli prázdne alebo to nebol JPEG, PNG, GIF, WebP či PDF.",
  "error.attachType": "Priložte JPEG, PNG, GIF, WebP alebo PDF.",
  "error.subjectLong": "Predmet je príliš dlhý.",
  "error.emailTextLong": "Údaje žiadosti sú príliš dlhé.",
  "error.shortenSubject": "Skráťte túto hodnotu, aby predmet e-mailu zostal do {max} znakov.",
  "error.shortenBody":
    "Skráťte údaje o zásielke alebo poznámku, aby e-mail zostal do {max} znakov.",

  "announce.choose": "Vyberte, ako chcete požiadať o cenovú ponuku",
  "announce.quickfill": "Rýchle vyplnenie: prilepte údaje alebo nahrajte dokument",
  "announce.route": "Krok 1 z 5: trasa a objednávka",
  "announce.shipment": "Krok 2 z 5: údaje o zásielke",
  "announce.services": "Krok 3 z 5: ďalšie služby",
  "announce.contact": "Krok 4 z 5: kontaktné údaje",
  "announce.review": "Krok 5 z 5: skontrolujte žiadosť",
  "announce.received": "Žiadosť prijatá",
  "announce.sendFailed": "Vašu žiadosť sa nepodarilo odoslať",
  "announce.sendFailedAttempt": "Vašu žiadosť sa nepodarilo odoslať (pokus {n})",
  "announce.completeFields": "Pred pokračovaním vyplňte označené polia.",
  "announce.sending": "Odosielanie vašej žiadosti…",
};
